<template>
  <div class="row col-12 visibility-container">
    <div :class="[isNew ? 'col-12' : 'col-6']" id="container-left">
      <DatosGrupo
        :dataAmbito="ambito"
        @saveData="setData"
        @validationError="haveError"
      />
    </div>
    <div class="col-6" id="container-right" v-if="!isNew">
      <Visibilidad :dataAmbito="ambito" @updateVisibleForAll="updateVisibleForAll"/>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import DatosGrupo from '../components/DatosGrupo.vue';
import Visibilidad from '../components/Visibilidad.vue';

export default {
  components: {
    DatosGrupo,
    Visibilidad
  },
  mixins: [Message],
  props: {
    dataAmbito: Object,
    isNew: Boolean
  },
  mounted () {
    this.$eventHub.$on('EJECUCION_NUEVO', ({ callback, rejected }) => {
      this.$eventHub.$emit('HAVE_ERROR');
      this.saveData(callback, rejected);
    });
    this.$eventHub.$on('ACTUALIZAR_INFORMACION', ({ callback, rejected }) =>
      this.saveData(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('EJECUCION_NUEVO');
    this.$eventHub.$off('ACTUALIZAR_INFORMACION');
  },
  computed: {},
  validations: {},
  data () {
    return {
      ambito: null,
      save: {
        name: null,
        visible: true,
        visibleForAll: true
      },
      validationError: false
    };
  },
  methods: {
    updateVisibleForAll (visibleForAll) {
      this.save.visibleForAll = visibleForAll;
    },
    haveError (val) {
      this.validationError = val;
    },
    setData (arr) {
      Object.entries(arr).forEach(([key, value]) => {
        this.save[key] = value;
      });
    },
    async saveData (callback, rejected) {
      let returnValue = {
        data: null,
        status: false
      };

      if (this.validationError) {
        rejected(returnValue);
        return;
      }

      if (this.isNew) {
        returnValue = await this.saveNewAmbito();
      } else {
        returnValue = await this.saveUpdates();
      }
      if (returnValue.status) {
        callback(returnValue);
      } else {
        rejected(returnValue);
      }
    },
    async saveNewAmbito () {
      let request = {
        controller: '/Ambito/',
        filter: {},
        body: this.save
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then(response => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch(err => {
          this.showError(err);

          responseData = {
            data: null,
            status: false
          };
        });
      return responseData;
    },
    async saveUpdates () {
      let idAmbito = this.$route.params.idAmbito
        ? this.$route.params.idAmbito
        : null;

      let responseData = null;

      if (idAmbito === null) {
        return (responseData = {
          data: null,
          status: false
        });
      }
      let request = {
        controller: '/Ambito/' + idAmbito,
        filter: {},
        body: this.save
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then(response => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch(err => {
          this.showError(err);
          responseData = {
            data: null,
            status: false
          };
        });

      return responseData;
    }
  },
  watch: {
    dataAmbito: {
      handler: function () {
        this.ambito = this.dataAmbito;
        // Needed reset array groups
        if (Object.entries(this.dataAmbito).length > 0) {
          this.setData(this.ambito);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.visibility-container {
  display: flex;
  justify-content: space-between;
  #container-left {
    padding-right: 17px;
  }
  #container-right {
    padding-left: 17px;
  }
}
</style>
